import { gql } from 'apollo-boost';

export const SET_FOLDER_MANUAL_MESSAGE_SORT = gql`
    mutation($data: SetFolderManualMessageSortInput!) {
        setFolderManualMessageSort(data: $data) {
            id
            manualMessageSortEnabled
        }
    }
`;
